import React from "react";
import { useLocation, Link } from "react-router-dom";
import styled from "styled-components";
import { Container } from "./Grid";

const crumbs = [
  {
    label: "Find My Chair",
    path: "/find-chair",
    visiblePaths: ["/find-chair", "/chair"],
  },
  {
    label: "Chair Profile",
    path: "CURRENT",
    visiblePaths: ["/chair"],
  },

  {
    label: "Choose Market",
    path: "/market",
    visiblePaths: ["/market", "/style", "/upholstery", "/series", "/build"],
  },
  {
    label: "Choose Style",
    path: "/style",
    visiblePaths: ["/style", "/upholstery", "/series", "/build"],
  },
  {
    label: "Choose Upholstery",
    path: "/upholstery",
    visiblePaths: ["/upholstery", "/series", "/build"],
  },
  { label: "Choose Series", path: "/series", visiblePaths: ["/series", "/build"] },
  { label: "Build A Chair", path: "/build", visiblePaths: ["/build"] },
];

const BreadcrumbLink = styled(Link)`
  color: ${({ theme }) => theme.secondary};
  text-transform: uppercase;
  font-weight: 700;
  font-size: 16px;
  line-height: 18px;
  margin-right: 0.35rem;
`;

const BreadcrumbStyle = styled.div`
  @media print {
    display: none;
  }
  background: ${({ theme }) => theme.gray};
  padding: 0.5rem 0;
`;

const Crumb = ({ label, path: _path, isLast }) => {
  const location = useLocation();

  const path = _path === "CURRENT" ? location.pathname : _path;

  const active = location.pathname.includes(path);

  return (
    <BreadcrumbLink to={{ pathname: path, state: location.state }} active={active}>
      {label} {!isLast && " /"}
    </BreadcrumbLink>
  );
};
const Breadcrumb = () => {
  const location = useLocation();

  const locationState = location.state || {};

  const secondSlashIndex = location.pathname.indexOf("/", 1);
  const endIndex = secondSlashIndex > 0 ? secondSlashIndex : undefined;
  const pathStart = location.pathname.substring(0, endIndex);

  const visibleCrumbs = crumbs.filter(({ visiblePaths, path }) => {
    if (!visiblePaths.includes(pathStart)) return false;
    if (path === "/upholstery" && locationState.style !== "foundation") return false;
    return true;
  });

  if (visibleCrumbs.length === 0) return null;

  return (
    <BreadcrumbStyle>
      <Container>
        <Crumb label="Chair Builder" path="/" isLast={false} />
        {visibleCrumbs.map(({ label, path }, i) => (
          <Crumb key={path} label={label} path={path} isLast={i + 1 === visibleCrumbs.length} />
        ))}
      </Container>
    </BreadcrumbStyle>
  );
};

export default Breadcrumb;
